export default {
	SET_TRANSACTION_PRODUCT(state, payload) {
		state.product = payload
	},
	SET_TRANSACTION_PAYMENT(state, payload) {
		state.payment = payload
	}
}